"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ productData, deliveryData, }) {
    const productPriceArr = productData.map(data => data.origin_price);
    const deliveryPriceArr = deliveryData
        .filter(data => data.delivery_type !== 0)
        .map(data => data.origin_price);
    const hasZeroPriceProduct = productPriceArr.includes(0);
    const hasZeroPriceDelivery = deliveryPriceArr.includes(0);
    return hasZeroPriceProduct && hasZeroPriceDelivery;
}
exports.default = default_1;
